import type { Range } from "@codemirror/state";
import { Decoration, type DecorationSet, ViewPlugin, type ViewUpdate } from "@codemirror/view";
import { TextEffects } from "../modifiers";

// const modRegEx = `${strings.textDecorations.bold}|${strings.textDecorations.italic}|${strings.textDecorations.underline}`;
const marks = {
  [TextEffects.animate]: Decoration.mark({ class: "cm-text-modifier-animate" }),
  [TextEffects.endAnimate]: Decoration.mark({ class: "cm-text-modifier-end-animate" }),

};

type TextEffect = keyof typeof TextEffects;

function getIndicesOfDecorations(mod: TextEffect, line: string, lineStartPos: number) {
  const positions = [];
  let pos = line.indexOf(TextEffects[mod]);
  while (pos !== -1) {
    positions.push(pos);
    pos = line.indexOf(TextEffects[mod], pos + 1);
  }
  return positions.map((pos) => pos + lineStartPos);
}

export const textEffectMarkers = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor() {
      this.decorations = Decoration.none;
    }

    update(update: ViewUpdate) {
      const textDecs: Range<Decoration>[] = [];
      for (const block of update.view.viewportLineBlocks) {
        const currentLine = update.state.doc.lineAt(block.from);
        const decorations: { [K in TextEffect]?: number[] } = {};

        const textEffects = Object.keys(TextEffects) as TextEffect[];

        for (const deco of textEffects) {
          decorations[deco] = getIndicesOfDecorations(deco, currentLine.text, currentLine.from);
        }

        const decorationsKeys = Object.keys(decorations) as TextEffect[];
        for (const key of decorationsKeys) {
          const currentDecorationArr = decorations[key];

          if (currentDecorationArr?.length) {
            for (const from of currentDecorationArr) {
              const deco = marks[TextEffects[key]];
              const to = from + TextEffects[key].length;
              if (to > from) {
                textDecs.push(deco.range(from, to));
              }
            }
          }
        }
        this.decorations = Decoration.set(textDecs, true);
      }
    }
  },
  {
    decorations: v => v.decorations,
  },
);
